import { create } from 'zustand';

/**
 * Which conversation this tab is showing (mobile messagingStore's
 * `activeConversationId`). A message that arrives there is being read, so it
 * does not count as unread.
 */
interface ChatPresenceState {
  openConversationId: string | null;
  setOpenConversation: (conversationId: string | null) => void;
}

export const useChatPresenceStore = create<ChatPresenceState>()((set) => ({
  openConversationId: null,
  setOpenConversation: (openConversationId) => set({ openConversationId }),
}));
